import React, { useState } from 'react';
import { Box, Stack } from '@mui/material';
import DashboardSidebar from './dashboardSidebar';
import Footer from './Footer';

const LayoutWithSidebar = ({
  children,
  margin,
  isOverlay = false,
  hideFooter = false,
  disableMainScroll = false,
}: {
  children: React.ReactNode;
  margin?: number;
  isOverlay?: boolean;
  hideFooter?: boolean;
  disableMainScroll?: boolean;
}) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/* Sidebar - Full Height */}
      <Box sx={{ flexShrink: 0 }}>
        <DashboardSidebar
          collapsed={isSidebarCollapsed}
          onCollapsedChange={setIsSidebarCollapsed}
        />
      </Box>

      {/* Main Content Area with Footer */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
        }}
      >
        {/* Main Content */}
        <Box
          component="main"
          sx={{
            width: isOverlay ? '100%' : 'auto',
            flexGrow: 1,
            backgroundColor: '#FFFFFF',
            overflow: disableMainScroll ? 'hidden' : 'auto',
            position: 'relative',
            visibility: 'inherit',
          }}
        >
          <Stack
            spacing={1}
            sx={{
              m: margin,
              height: '100%',
              position: 'relative',
            }}
          >
            {children}
          </Stack>
        </Box>

        {/* Footer */}
        {!hideFooter && (
          <Box sx={{ flexShrink: 0 }}>
            <Footer themeMode="light" />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default LayoutWithSidebar;
